module.exports = __webpack_public_path__ + "img/cover-9.18d5426a.jpg";